<template>
  <div class="recorddeteilpage">
    <div class="flexbox">
      <div class="paylist">
        <span class="listline"></span>
        <p class="paylisttit">
          <span class="title">挂号信息</span>
        </p>
        <div class="payliscon">
          <p>
            <span>就诊科室：</span>
            <span>{{regInfo.DptName}}</span>
          </p>
          <p>
            <span>就诊医生：</span>
            <span>{{regInfo.DoctorName}}</span>
          </p>
          <p>
            <span>就诊号：</span>
            <span>{{regInfo.Code}}</span>
          </p>
          <p>
            <span>挂号费：</span>
            <span>¥{{regInfo.Amount}}</span>
          </p>
          <p>
            <span>科室区域：</span>
            <span>{{regInfo.Address}}</span>
          </p>
          <p>
            <span>预估就诊时间：</span>
            <span>{{regInfo.VisitDate}}</span>
          </p>
          <div class="status">
            <span :class="regInfo.State!=2?'statusred':'statusgray'">{{regInfo.StateName}}</span>
          </div>
        </div>
      </div>
      <div class="prompt">
        <p>温馨提示：</p>
        <p>取消预约挂号成功后如需退号，请于就诊前{{regInfo.BackNumberTime}}小时前在手机APP上取消预约，就诊当日不支持手机退号，需到窗口进行退号操作，若退号时间超过预约就诊日期的工作开始时间，手机APP和医院收费窗口一律不能退号。</p>
      </div>
    </div>

    <div class="bnt" v-show="isshow(2)">
      <span @click="registerfun()">再次预约</span>
    </div>
    <div class="surebnt" v-show="isshow(1)">
      <span @click="registerfun()" class="mr20">重新预约</span>
      <span @click="bankhome">返回首页</span>
    </div>
    <div class="surebnt" v-show="!showButton">
      <span @click=" hISBackNumber()" class="mr20">取消预约</span>
      <span @click="bankhome">返回首页</span>
    </div>
  </div>
</template>
<script>
  import { GetRegInfoByRegID, HISBackNumber } from "@/services/getData.js";
  import weui from "weui.js";
  export default {
    name: "personal-recorddeteil",
    data() {
      return {
        regID: this.$route.query.regID,
        regInfo: [],
        $dialog: [],
        showButton: true
      };
    },
    created: function () {
      this.getRegInfoByRegID();
    },
    methods: {
      bankhome() {
        //返回首页
        this.$router.push({ path: "/", params: { userId: 123 } });
      },
      getRegInfoByRegID() {
        var loading = weui.loading("loading", {
          className: "custom-classname",
          content: "加载中"
        });
        GetRegInfoByRegID(this.regID).then(response => {
          loading.hide();
          if (response.data) {
            this.regInfo = response.data;
            if (response.data.State == 0) {
              this.showButton = false;
            } else {
              this.showButton = true;
            }
          }
        });
      },
      registerfun() {
        //跳转到预约挂号(选择院区)
        this.$router.push({ path: "/home/choose" });
      },
      hISBackNumber() {
        var _that = this;
        _that.$dialog = weui.dialog({
          content: "是否确定取消预约",
          className: "custom-classname",
          buttons: [
            {
              label: "否",
              type: "default",
              onClick: function () { }
            },
            {
              label: "是",
              type: "primary",
              onClick: function () {
                var loading = weui.loading("loading", {
                  className: "custom-classname",
                  content: "加载中"
                });
                _that.$dialog.hide(function () {
                  HISBackNumber(_that.regID).then(response => {
                    loading.hide();
                    if (response.data.Result) {
                      _that.$dialog = weui.dialog({
                        title: "提示",
                        content: "您已退号成功，费用会在3个工作日内原路返还"
                      });
                      _that.getRegInfoByRegID();
                    } else {
                      _that.$dialog = weui.dialog({
                        title: "提示",
                        content: response.data.Content
                      });
                    }
                  });
                });
              }
            }
          ]
        });
      },
      isshow(type) {
        if (type == 3) {
          if (type == this.regInfo.State) {
            return false;
          }
          return true;
        }
        if (type == this.regInfo.State) {
          return true;
        }
        return false;
      }
    }
  };
</script>
<style>
  .recorddeteilpage {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

    .recorddeteilpage > .flexbox {
      flex: 1;
    }

    .recorddeteilpage .paylist {
      /* padding: 0 0.2rem; */
      box-sizing: border-box;
      width: 100%;
      height: auto;
      background-color: white;
      position: relative;
      margin-bottom: 0.2rem;
    }

    .recorddeteilpage .paylisttit {
      font-size: 0.26rem;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: #1592e4;
      border-bottom: 0.01rem solid rgba(61, 151, 209, 1);
      height: 0.79rem;
      line-height: 0.8rem;
      padding-left: 0.2rem;
      box-sizing: border-box;
      width: 100%;
    }

    .recorddeteilpage .prompt {
      margin-left: 0.2rem;
      font-size: 0.2rem;
      color: #999999;
      margin-top: 0.2rem;
    }

    .recorddeteilpage .payliscon {
      width: 100%;
      box-sizing: border-box;
      padding: 0 0.2rem;
    }

    .recorddeteilpage .paylist > .payliscon > p {
      width: 100%;
      border-bottom: 0.01rem dotted #dddddd;
      height: 0.79rem;
      line-height: 0.8rem;
      font-size: 0.26rem;
      font-family: MicrosoftYaHei;
      font-weight: 400;
    }

      .recorddeteilpage .paylist > .payliscon > p > span:first {
        color: #333333;
        text-align: left;
      }

      .recorddeteilpage .paylist > .payliscon > p > span:last-child {
        color: #999999;
        text-align: right;
        float: right;
      }

    .recorddeteilpage .listline {
      display: block;
      position: absolute;
      width: 0.08rem;
      height: 0.8rem;
      background: rgba(21, 146, 228, 1);
      top: 0;
      left: 0;
    }

    .recorddeteilpage .status {
      height: 0.74rem;
      line-height: 0.74rem;
      font-size: 0.26rem;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      text-align: right;
    }

    .recorddeteilpage .statusred {
      color: red;
    }

    .recorddeteilpage .statusgreen {
      color: #579c53;
    }

    .recorddeteilpage .statusgray {
      color: #999999;
    }

    .recorddeteilpage .bnt {
      /* flex: 1; */
      background-color: #1592e4;
      height: 0.8rem;
      margin: 0.2rem;
      font-family: "MicrosoftYaHei";
      font-size: 0.26rem;
      color: #fffefe;
      text-align: center;
      line-height: 0.8rem;
    }

      .recorddeteilpage .bnt > span {
        display: inline-block;
        width: 100%;
        height: 100%;
      }

    .recorddeteilpage .surebnt {
      height: 0.8rem;
      margin: 0.2rem;
      font-family: "MicrosoftYaHei";
      font-size: 0.26rem;
      color: #fffefe;
      text-align: center;
      line-height: 0.8rem;
      display: flex;
      margin-top: 0.3rem;
    }

      .recorddeteilpage .surebnt > span {
        width: 50%;
        display: inline-block;
        /* margin-right: 0.2rem; */
        background-color: #1592e4;
      }

      .recorddeteilpage .surebnt .mr20 {
        margin-right: 0.2rem;
      }
</style>




// WEBPACK FOOTER //
// src/components/person/personal-recorddeteil.vue